<template>
	<div id="content_body">
		<!-- :instanceClass="instanceClassAttr.instanceClass" -->
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<!-- @submit.prevent="handleSubmit()" -->
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<!-- <div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.label')}}
									</label>
									<input type="text" v-model="instance.lib" class="form-control" lang="fr" :disabled="typeView=='show'"/>
								</b-form-group>				
							</div> -->
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
									</label>
									<select v-model="prsStoreSelected" 
										class="form-control" :disabled="typeView=='show'">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id" >
										{{ prsStore.storeName }}
										</option>
									</select>					
								</b-form-group>
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.dateStart')}}
									</label>
									<input type="text" v-model="instance.dateStart" class="form-control" lang="fr" :disabled="typeView=='show'"/>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.dateEnd')}}
									</label>
									<input type="text" v-model="instance.dateEnd" class="form-control" lang="fr" :disabled="typeView=='show'"/>
								</b-form-group>				
							</div>

							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.nbreDebit')}}
									</label>
									<input type="number" v-model="instance.nbreDebit" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.amountDebit')}}
									</label>
									<input type="text" v-model="instance.amountDebit" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.nbreCredit')}}
									</label>
									<input type="number" v-model="instance.nbreCredit" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.amountCredit')}}
									</label>
									<input type="text" v-model="instance.amountCredit" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>

							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.accountTot')}}
									</label>
									<input type="text" v-model="instance.accountTot" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.username')}}
									</label>
									<input type="text" v-model="instance.usernameLib" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
	
						</div>
						
					</b-form>
					<div class="row">
						
						<div class="col-md-4" align="left">
							
							<b-button 
								v-if="typeView == 'show' && instance.active && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])" class="btn btn-danger" 
								@click="instance.typeValid = 'stop'; axiosValid()">
								<span>
									<fa icon="dot-circle"/>
									{{ $t("mvtfinancialstatement.button.stop")}}
								</span>
							</b-button> 
							<b-button
								v-if="typeView == 'show' && !instance.active && !instance.valStatement && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])" class="btn btn-warning"
								@click="instance.typeValid = 'start'; axiosValid()">
								<span>
									<fa icon="play-circle"/>
									{{ $t("mvtfinancialstatement.button.start")}}
								</span>
							</b-button>

						</div>
						<div class="col-md-4" align="center">
							<b-button
								v-if="typeView == 'show' && !instance.active && !instance.valStatement && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])" class="btn btn-success"
								@click="instance.typeValid = 'valid'; axiosValid()">
								<span>
									<fa icon="check-circle"/>
									{{ $t("mvtfinancialstatement.button.valid")}}
								</span>
							</b-button>
						</div>
							
						
						<div v-if="typeView == 'show'" class="col-md-4" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce()">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('mvtfinancialstatement.button.print')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>
				</div>
				<div class="card-body p-4 p-md-5">
					<!-- DATA -->
					<div class="datatable">
						<datatable-instance
							:instanceClassAttr="instanceClassMvt"
							ref="componentDatatableInstance"
						/>
					</div>

					<!-- Movements table-->
					<!-- <div class="table-responsive">
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="25%">
										{{ $t('mvtmovement.mvtTypeDep')}}
									</th>
									<th scope="col" width="10%" class="align-center">
										{{ $t('mvtmovement.justificatif')}}
									</th>
									<th scope="col" width="15%" class="align-center">
										{{ $t('mvtmovement.mvtTypeMvt')}}
									</th>
									<th scope="col" width="10%" class="align-right">
										{{ $t('mvtmovement.mvtAmount')}}
									</th>
									<th scope="col" width="10%" class="align-right">
										{{ $t('mvtmovement.mvtSolde')}}
									</th>
									<th scope="col" width="25%" class="align-center">
										{{ $t('mvtmovement.mvtDate')}}
									</th>
									<th scope="col" width="25%" class="align-center">
										{{ $t('mvtmovement.username')}}
									</th>
								</tr>
							</thead>
							<tbody>
								
								<tr class="border-bottom" v-for="mvtMovement in instance.mvtMovements" :key="mvtMovement.id">
									<td>
										<div class="font-weight-bold">
											{{mvtMovement.mvtTypeDepLib}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold">
											{{mvtMovement.justificatif}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold">
											{{mvtMovement.mvtTypeMvtLib}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount(mvtMovement.mvtAmount)}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount(mvtMovement.mvtSolde)}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold">
											{{$moment(mvtMovement.mvtDate).format($store.getters.formatDate)}}
										</div>
									</td>
									<td>
										<div class="font-weight-bold">
											{{mvtMovement.usernameLib}}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div> -->
				

				</div>

			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue'
	export default {
		name: 'mvtFinancialStatement',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		components: {
			'header-layout': Header,
			'modal-pdf-viewer': ModalPdfViewer,
			'datatable-instance': DatatableInstance,
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtfinancialstatement.label'),
				pageTitle: this.$t('mvtfinancialstatement.show'),
				pageIcon: 'power-off',
				instanceClassAttr: {
					instanceClass: 'mvtfinancialstatement'
				},
				instanceClassMvt: {
					instanceClass: 'mvtmovement',
					typeItems: 'itemsInit',
					actCol: {
						actDisplay: false, 
						thCol: '7%',
						thClass: 'align-center',
						// actAlign: 'right',
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false
					},
					attrsList:[
						{attrName:'mvtTypeDepLib', thStyle: {width:'20%'}, thClass:'align-center'},
						{attrName:'justificatif', thStyle: {width:'20%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'mvtTypeMvtLib', thStyle: {width:'10%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'mvtAmount', thStyle: {width:'10%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'mvtSolde', thStyle: {width:'10%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'mvtDate', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'username', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true}
					]
				},

				instance: {},
				amountLetter: {},
				prsStoreList: [],
				prsStoreSelected: null,
				typeView: 'show',
				pdfSrc:'',
				pdfName:"Bon de l'inventaire",

				/*fields: [
					{key:'mvtTypeDepLib', label:this.$t('mvtmovement.mvtTypeDep'), thStyle: {width:'20%'}, class:'align-center'},
					{key:'justificatif', label:this.$t('mvtmovement.justificatif'), thStyle: {width:'20%'}, class:'align-center', searchable: true, sortable: true},
					{key:'mvtTypeMvtLib', label:this.$t('mvtmovement.mvtTypeMvt'), thStyle: {width:'10%'}, class:'align-center', searchable: true, sortable: true},
					{key:'mvtAmount', label:this.$t('mvtmovement.mvtAmount'), thStyle: {width:'10%'}, class:'align-center', searchable: true, sortable: true},
					{key:'mvtSolde', label:this.$t('mvtmovement.mvtSolde'), thStyle: {width:'10%'}, class:'align-center', searchable: true, sortable: true},
					{key:'mvtDate', label:this.$t('mvtmovement.mvtDate'), thStyle: {width:'15%'}, class:'align-center', searchable: true, sortable: true},
					{key:'username', label:this.$t('mvtmovement.username'), thStyle: {width:'15%'}, class:'align-center', searchable: true, sortable: true}
				]*/

			}
		},
		async mounted () {
			this.$store.dispatch('initFlash');
			/*this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})*/
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'mvtfinancialstatement',
						id: this.itemId
					})
					.then(response => {
						this.instance = response.data

						this.instance.dateStart = this.$moment(this.instance.dateStart).format(this.$store.getters.formatDate)
						this.instance.dateEnd = this.$moment(this.instance.dateEnd).format(this.$store.getters.formatDate)
						
						this.amountToLetter({target:{value:this.instance.accountTot?.toString()}}, 'accountTotRep')

						this.instance.accountTot = this.$store.getters.formatAmount(this.instance.accountTot)
						this.instance.amountDebit = this.$store.getters.formatAmount(this.instance.amountDebit)
						this.instance.amountCredit = this.$store.getters.formatAmount(this.instance.amountCredit)
						this.prsStoreSelected = this.instance.prsStore.id
						this.pageSubtitle = this.instance.lib

						

						// this.instance.mvtMovements = this.instance.mvtMovements.sort()//sort((a, b) => b - a)

						this.instance.mvtMovements = this.instance.mvtMovements.sort((a, b) => b.id - a.id)
						
						this.$refs.componentDatatableInstance.refreshDataTable(this.instance.mvtMovements);

						// this.instance.mvtMovement = []
						/*this.instance.mvtMovements.forEach(servOp => {
							
							if(servOp?.servTypeStockES?.servService?.serviceCode == 'P' )
								this.instance.servOps?.push(servOp)
						})*/
						
						

					})
					.catch(error => {
						console.log('error catch get mvtfinancialstatement by itemId == ', error.message)
					})
				}
			}
		},
		methods: {
			async editItem(){
				if(this.typeView == 'edit')
					this.$router.go(0)
				else {
					this.typeView = 'edit'
					// on ajoute les autres stocks
					this.instance.servOps.forEach(servOp => {
						if(this.servTypeServs[servOp.servTypeLib]){
							servOp.stock = this.servTypeServs[servOp.servTypeLib].stock
							delete this.servTypeServs[servOp.servTypeLib];
						}
					})
					let servOps = Object.values(this.servTypeServs);
					this.instance.servOps.push(...servOps);
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async handleSubmit() {
				this.instance.prsStore = this.prsStoreSelected		
				const result = await this.v$.$validate()
				if (!result){
					return
				}
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			
			async axiosValid() { //this.instance.typeValid
				try {
					if(this.itemId && !isNaN(this.itemId)){
						if(this.instance.typeValid === 'stop' || this.instance.typeValid === 'start'){
							await this.$store.dispatch('axiosPut', {
								domain: 'mvtfinancialstatement/stoporstartstatement',
								data: this.instance,
								id:this.itemId
							})
							.then(res => {
								// console.log('res axiosValid === ', res)
								this.$nextTick(() => {
									let msg = this.$t("mvtfinancialstatement.label") + " "+this.itemId;
									if(res.data && res.data.error){
										msg = msg+ ' '+ res.data.error;
										this.$store.dispatch('showToast', {
											type: 'warning', message: msg
										});
										this.$router.push('/mvtfinancialstatement/show/'+this.itemId)
									}
									else{
										this.$store.dispatch('showToast', {
											type: 'success', message: this.$t('toast.received.message', { obj: msg})
										});
										this.$router.go(0)
									}
									// this.$router.go(0)
									this.$router.push('/mvtfinancialstatement/show/'+this.itemId)
									this.$store.dispatch('unloading')
								});
							})
							.catch(error => {
								console.log('error axiosValid === ', error)
								this.$store.getters.getErrorMsgFormatted(error);
								this.$store.dispatch('unloading')
							})
						}

						else if(this.instance.typeValid === 'valid'){
							await this.$store.dispatch('axiosPut', {
								domain: 'mvtfinancialstatement/confirmstatement',
								data: this.instance,
								id:this.itemId
							})
							.then(res => {
								// console.log('res axiosValid === ', res)
								this.$nextTick(() => {
									let msg = this.$t("mvtfinancialstatement.label") + " "+this.itemId;
									if(res.data && res.data.error){
										msg = msg+ ' '+ res.data.error;
										this.$store.dispatch('showToast', {
											type: 'warning', message: msg
										});
										this.$router.push('/mvtfinancialstatement/show/'+this.itemId)
									}
									else{
										this.$store.dispatch('showToast', {
											type: 'success', message: this.$t('toast.received.message', { obj: msg})
										});
										this.$router.go(0)
									}
									// this.$router.go(0)
									this.$router.push('/mvtfinancialstatement/show/'+this.itemId)
									this.$store.dispatch('unloading')
								});
							})
							.catch(error => {
								console.log('error axiosValid === ', error)
								this.$store.getters.getErrorMsgFormatted(error);
								this.$store.dispatch('unloading')
							})
						}
					}
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = "FICHE DE L'ARRÊTÉ DU "+ this.instance.dateStart + ' AU '+ this.instance.dateEnd;

				modelName = modelName + '<br><br> <FONT size="2"; color="red"><i> '+ this.$t(this.instanceClassAttr.instanceClass +'.accountTot') +' : </i> <b>'+this.instance.accountTot +'</b> </FONT>';

				let titreDoc = this.$t('mvtmovement.list')

				let strParams = "jasper=LIC&typeList=hasMany&strFormat=PDF"

				let strParamsForms = "";
				let attrsRepList = ['mvtTypeDep', 'mvtTypeMvt', 'mvtAmount', 'mvtDate', 'username']
				let attrsRepLibList = ['Opération', 'Débit/Crédit', 'Montant', 'Date', 'Agent']

				strParamsForms = "classHasMany=com.altis.movement.MvtMovement&attrHasMany=mvtMovements&valHasMany="+this.itemId +"&logHasMany=eqL"

				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()

				let detailsTopC1 = '';
				let detailsTopC2 = '';

				detailsTopC1 = '<i> '+ this.$t(this.instanceClassAttr.instanceClass +'.nbreDebit') +' : </i> <b> ' +this.$store.getters.formatNumber(this.instance?.nbreDebit) + '</b>';

				detailsTopC2 = '<i> '+ this.$t(this.instanceClassAttr.instanceClass +'.nbreCredit') +' : </i> <b> ' +this.$store.getters.formatNumber(this.instance?.nbreCredit) + '</b>';
				
				detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t(this.instanceClassAttr.instanceClass +'.amountDebit') +' : </i> <b> ' +this.instance.amountDebit + '</b>';

				detailsTopC2 = detailsTopC2 +'<br><i> '+ this.$t(this.instanceClassAttr.instanceClass +'.amountCredit') +' : </i> <b> ' +this.instance.amountCredit + '</b>';


				let trFoot = ''
				let	detailsBot = '';
				let libBot = ''

				libBot = '<i> '+ this.$t(this.instanceClassAttr.instanceClass +'.accountTot') +' : </i> <b>'+this.instance.accountTot +'</b>';
				detailsBot = '<i><b> '+this.amountLetter.accountTotRep +'</b> </i>';	


				let detailsBot3C = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.dateCreated).format(this.$store.getters.formatDateShort) + '</b>';

  
				let	detailsTop = '<FONT size=4><b>'+modelName+' </b> </FONT>';
				
				// let strParams = "jasper=LIC&typeList=hasMany&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				if(detailsBot3C != '')
					strParams = strParams +"&detailsBot3C="+detailsBot3C
				
				if(strParamsForms != "")
					strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+titreDoc

				let fileName = modelName
				strParams = strParams + "&fileName="+ fileName
			
				await this.$store.dispatch('axiosGet', {
					url: '/api/'+this.instanceClassAttr.instanceClass+'/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},
		}
		
	}

</script>